import { NavController } from '@ionic/angular';
import { Component, Input, OnInit } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

// This button lives in app.component, outside the lazy page modules that
// register Portuguese, so register it here for the price below.
registerLocaleData(localePt);

@Component({
  selector: 'app-view-checkout',
  templateUrl: './view-checkout.component.html',
  styleUrls: ['./view-checkout.component.scss'],
})
export class ViewCheckoutComponent implements OnInit {
  @Input() style: string;
  @Input() itemCount: number = 0;
  @Input() totalPrice: number = 0;

  constructor(private navCtrl: NavController) {}

  ngOnInit() {}

  showPage() {
    this.navCtrl.navigateForward('checkout');
  }
}
